import { graphql } from 'react-relay';
import type { GraphQLTaggedNode } from 'react-relay';

import { useEditorContentFragment } from '@confluence/editor-content-unified-query/entry-points/useEditorContentFragment.ts';
import type {
	EditorContentFragmentResult,
	EditorContentFragmentValue,
} from '@confluence/editor-content-unified-query/entry-points/useEditorContentFragment.ts';

import type { useEditorSpaceDetailFragment_content$key } from './__generated__/useEditorSpaceDetailFragment_content.graphql.ts';

// The page's space for EditorContentUnifiedQuery, with the fields of useSpaceDetailQuery without
// spaceTypeSettings, so SpaceDetailProvider can share it with useSpaceDetail.
const editorSpaceDetailFragmentNode: GraphQLTaggedNode = graphql`
	fragment useEditorSpaceDetailFragment_content on Content @catch {
		space {
			id
			key
			alias
			...SpaceDetail_space
		}
	}
`;

/** The editor document's space from EditorContentUnifiedQuery. */
export function useEditorSpaceDetailFragment({
	contentId,
}: {
	contentId: string | undefined;
}): EditorContentFragmentResult<
	EditorContentFragmentValue<useEditorSpaceDetailFragment_content$key>
> {
	return useEditorContentFragment<useEditorSpaceDetailFragment_content$key>(
		'editorSpaceDetailFragment',
		editorSpaceDetailFragmentNode,
		{ contentId },
	);
}
